import { createStore, applyMiddleware, Store, compose, combineReducers } from 'redux';

import createSagaMiddleware from 'redux-saga';
import ActionLogger from './middlewares/action-logger';
import NotificationMiddleware from './middlewares/notification-middleware';
import SpinnerMiddleware from './middlewares/spinner-middleware';
import RequestMiddleware from './middlewares/request-middleware';
import GoogleAnalytics from './middlewares/google-analytics-middleware';
import rootSaga from './sagas/sagas';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { Log } from 'ng2-logger';
import { routerMiddleware } from 'react-router-redux';
import { connectRouter } from 'connected-react-router';
import LoginReducer from './reducers/login';
import mainMenuReducer from './reducers/mainMenu';
import assignmentReducer from './reducers/assignment';
import storageManagementReducer from './reducers/storageManagement';
import UserHomePageReducer from './reducers/userHome';
import userPreference from './reducers/userPreference';
import coursePageReducer from './reducers/coursePage';
import messageReducer from './reducers/message';
import AnnoucementReducer from './reducers/announcement';
import virtualClassReducer from './reducers/virtualClass';
import documentReducer from './reducers/document';
import elessonReducer from './reducers/elesson';
import enrollmentReducer from './reducers/enrollment';
import linkReducer from './reducers/link';
import surveyReducer from './reducers/survey';
import profileReducer from './reducers/profile';
import videoReducer from './reducers/video';
import forumReducer from './reducers/forum';
import usersReducer from './reducers/users';
import projectReducer from './reducers/project';
import reportReducer from './reducers/report';
import examReducer from './reducers/exam';
import examSessionReducer from './reducers/examSession';
import calendarReducer from './reducers/calendar';
import questionReducer from './reducers/question';
import helpDeskReducer from './reducers/helpDesk';
import notificationReducer from './reducers/notification';
import ltiReducer from './reducers/lti';
import activityCopyReducer from './reducers/activityCopy';
import activityMultiplyReducer from './reducers/activityMultiply';
import informationNoteReducer from './reducers/informationNote';
import iFrameReducer from './reducers/iFrame';
import gradebookReducer from './reducers/gradebook';
import filesReducer from './reducers/files';
import qrPollingReducer from './reducers/qrPolling';
import translationReducer from './reducers/translation';
import LearningOutcomesReducer from './reducers/learningOutcomes';
import MadlenIntegrationReducer from './reducers/madlenIntegration';

const _logger = Log.create('Store');


const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
    key: 'almsPlusPersist',
    storage,
    whitelist: ['enrollment', 'login', 'profile','userHomePage','coursePage']
};

declare global {
    // tslint:disable-next-line
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;



export default (browserHistory: any) => {

    const persistReducerParameter = persistReducer(persistConfig, combineReducers({
        login: LoginReducer,
        enrollment: enrollmentReducer,
        coursePage: coursePageReducer,
        mainMenuRoot: mainMenuReducer,
        userHomePage: UserHomePageReducer,
        assignment: assignmentReducer,
        storageManagement: storageManagementReducer,
        announcement: AnnoucementReducer,
        virtualClass: virtualClassReducer,
        message: messageReducer,
        userPreference,
        document: documentReducer,
        elesson: elessonReducer,
        link: linkReducer,
        profile: profileReducer,
        translation: translationReducer,
        reports: reportReducer,
        qrPolling: qrPollingReducer,
        learningOutcomes: LearningOutcomesReducer,
        madlenIntegration: MadlenIntegrationReducer,
        video: videoReducer,
        forum: forumReducer,
        users: usersReducer,
        project: projectReducer,
        notification: notificationReducer,
        exam: examReducer,
        examSession: examSessionReducer,
        calendar: calendarReducer,
        question: questionReducer,
        helpDesk: helpDeskReducer,
        iFrame: iFrameReducer,
        lti: ltiReducer,
        survey: surveyReducer,
        activityCopy:activityCopyReducer, 
        activityMultiply:activityMultiplyReducer, 
        informationNote: informationNoteReducer,
        gradebook: gradebookReducer,
        files:filesReducer,
        router: connectRouter(browserHistory)
    }));
    const routermw = routerMiddleware(browserHistory);
    let reduxStore: any;
    if (process.env.NODE_ENV === 'development') {
        reduxStore = createStore(
            persistReducerParameter,
            composeEnhancers(applyMiddleware(ActionLogger, NotificationMiddleware, sagaMiddleware, SpinnerMiddleware, RequestMiddleware, routermw, GoogleAnalytics))
        );
    } else if (process.env.NODE_ENV === 'production') {
        reduxStore = createStore(
            persistReducerParameter,
            applyMiddleware(ActionLogger, NotificationMiddleware, sagaMiddleware, SpinnerMiddleware, RequestMiddleware, routermw, GoogleAnalytics)
        );
    }
    const storePersistor = persistStore(reduxStore, undefined, () => {
        //
    });

    sagaMiddleware.run(rootSaga);
    return { reduxStore, storePersistor };
};
